var _circle, _circle2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRez2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 331,
    height: 331,
    viewBox: "0 0 331 331",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 166.5,
    cy: 165.5,
    r: 145.5,
    fill: "url(#paint0_linear_525_547)",
    fillOpacity: 0.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 165.5,
    r: 162.5,
    stroke: "url(#paint1_linear_525_547)",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_525_547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M231.863 205.109L231.104 204.856V187.631C231.104 186.364 230.093 185.351 228.829 185.351H168.649V163.82H241.219C242.483 163.82 243.494 162.806 243.494 161.54V84.2798C243.494 83.0132 242.483 82 241.219 82H91.2757C90.0114 82 89 83.0132 89 84.2798V161.793C89 163.06 90.0114 164.073 91.2757 164.073H163.845V185.351H104.424C103.16 185.351 102.148 186.364 102.148 187.631V204.856L101.39 205.109C94.0571 206.629 89 212.709 89 219.801C89 228.161 96.0799 235 104.424 235C112.768 235 119.848 228.161 119.848 219.801C119.848 212.455 114.791 206.376 107.711 205.109L106.7 204.856V189.911H164.351V204.856L163.592 205.109C156.512 206.629 151.455 212.709 151.455 219.801C151.455 228.161 158.535 235 166.879 235C175.223 235 182.303 228.161 182.303 219.801C182.303 212.455 177.246 206.376 170.166 205.109L169.408 204.856V189.911H227.059V204.856L225.542 205.109C218.462 206.629 213.405 212.709 213.405 219.801C213.405 228.161 220.485 235 228.829 235C237.173 235 244.253 228.161 244.253 219.801C244 212.455 238.943 206.376 231.863 205.109ZM115.044 219.801C115.044 225.627 110.24 230.44 104.424 230.44C98.6085 230.44 93.8042 225.627 93.8042 219.801C93.8042 213.975 98.6085 209.162 104.424 209.162C110.24 209.162 115.044 213.975 115.044 219.801ZM137.801 159.513H93.5514V86.5596H238.943V159.513H194.693V148.874C194.693 137.728 187.613 127.343 177.246 123.036L175.729 122.53L176.993 121.517C180.281 118.73 181.798 114.93 181.798 110.371C181.798 102.012 174.718 95.1722 166.374 95.1722C158.029 95.1722 150.949 102.265 150.949 110.371C150.949 114.424 152.719 118.477 155.754 121.517L156.765 122.53L155.248 123.036C144.628 127.343 137.801 137.728 137.801 148.874V159.513ZM166.121 120.757C160.305 120.757 155.501 115.944 155.501 110.118C155.501 104.291 160.305 99.4785 166.121 99.4785C171.936 99.4785 176.741 104.291 176.741 110.118C176.993 115.944 172.189 120.757 166.121 120.757ZM155.501 159.513V145.581C155.501 144.315 154.489 143.301 153.225 143.301C151.961 143.301 150.949 144.315 150.949 145.581V159.513H142.605V148.874C142.605 135.955 153.225 125.316 166.374 125.316C179.522 125.316 190.142 135.955 190.142 148.874V159.513H181.798V145.581C181.798 144.315 180.786 143.301 179.522 143.301C178.258 143.301 177.246 144.315 177.246 145.581V159.513H155.501ZM176.993 219.801C176.993 225.627 172.189 230.44 166.374 230.44C160.558 230.44 155.754 225.627 155.754 219.801C155.754 213.975 160.558 209.162 166.374 209.162C172.189 209.162 176.993 213.975 176.993 219.801ZM228.07 230.44C222.254 230.44 217.45 225.627 217.45 219.801C217.45 213.975 222.254 209.162 228.07 209.162C233.886 209.162 238.69 213.975 238.69 219.801C238.943 225.627 234.139 230.44 228.07 230.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.734 114.424H105.436V118.73H109.734V114.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.63 114.424H118.331V118.73H122.63V114.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.778 114.424H131.479V118.73H135.778V114.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.049 114.424H199.75V118.73H204.049V114.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.197 114.424H212.898V118.73H217.197V114.424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.093 114.424H225.795V118.73H230.093V114.424Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_525_547",
    x1: 58,
    y1: -22,
    x2: 231,
    y2: 450,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2AA89A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_525_547",
    x1: 108,
    y1: 21.5,
    x2: 189.5,
    y2: 367.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AA89A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.370306,
    stopColor: "#2AA89A",
    stopOpacity: 0.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_525_547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 153,
    fill: "white",
    transform: "translate(89 82)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRez2);
export default __webpack_public_path__ + "static/media/rez2.3224008d43116470c6218c8e59e5783b.svg";
export { ForwardRef as ReactComponent };